/**
 * @file Support Center
 *
 * Information Article page related components initialization
 */

import SelectorEngine from '../../../utils/dom/selector-engine';
import EventHandler from '../../../utils/dom/event-handler';
import Request from '../../../utils/request';

const CLICK_EVENT = 'click';

class InformationArticle {
    constructor() {
        this._wrapper = SelectorEngine.findOne('.lta-sc-information-article');
        this.init();
    }


    init() {
        if (!this._wrapper) {
			return;
		} else {
            this.fedbackBtnContainer = SelectorEngine.findOne('.sc-feeback-btn-container', this._wrapper);
            this.feedbackElement = SelectorEngine.findOne('.sc-feedback-text', this._wrapper);
            this.PageId = this.fedbackBtnContainer.getAttribute('data-sc-pageId');
            this.yesCta = SelectorEngine.findOne('.sc-feedback-yes-btn', this.fedbackBtnContainer);
            this.noCta  = SelectorEngine.findOne('.sc-feedback-no-btn', this.fedbackBtnContainer);

            EventHandler.on(this.yesCta, CLICK_EVENT, () => {
                this.sendUsefulInfoFeedback("yes");
            });

            EventHandler.on(this.noCta, CLICK_EVENT, () => {
                this.sendUsefulInfoFeedback("no");
            });
        }
    }

    sendUsefulInfoFeedback(feedback) {
        let data = {
            PageId: this.PageId,
            IsHelpful: feedback
        }
        Request.post('/api/Enquiry/InformationHelpful', data).catch((error) => {
            console.error(error)
        }).then((data) => {
            if(data.StatusCode === '02') {
                this.fedbackBtnContainer.classList.add('u-hidden');
                this.feedbackElement.classList.remove('u-hidden');
            } else {
                console.error(data.response);
            }
        })
    }
}

const informationArticle = new InformationArticle();

export default informationArticle;
